import store from "@/store";
import { readContract, writeContract, waitForTransaction } from "@wagmi/core";

const setupConfig = () => {
  const { fiat } = store.getState()?.contract?.infoWagmiConfig ?? {};
  return fiat;
};

// TODO: UPDATED SMC  VERSION V_2
const balanceOf = async (address: string) => {
  try {
    const data = (await readContract({
      ...setupConfig(),
      functionName: "balanceOf",
      args: [address],
    })) as any;
    return parseFloat(data);
  } catch (err) {
    return 0;
  }
};

const allowance = async (walletAddress: string, nftAddress: string) => {
  try {
    const data = (await readContract({
      ...setupConfig(),
      functionName: "allowance",
      args: [walletAddress, nftAddress],
    })) as any;
    return parseFloat(data);
  } catch (err) {
    throw err;
  }
};

const approve = async ({
  spender,
  value,
}: {
  spender: string;
  value: number;
}) => {
  try {
    const { hash } = await writeContract({
      ...setupConfig(),
      functionName: "approve",
      args: [spender, value],
    });
    const data = await waitForTransaction({
      hash,
    });
    return data;
  } catch (err) {
    throw err;
  }
};

export const fiatService = {
  balanceOf,
  allowance,
  approve,
};
